export default "__VITE_ASSET__Cevtp9_6__"